/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DataStoreService } from '../../../../../src/app/core/services/datastore.service';
import { AppUtilityService } from '../../../core/services/app-utility.service';
import { LmsLoaderService } from '../../../core/services/lms-loader.service';
import { LmsTabsDragDropService } from '../../../core/services/lms-tabs-drag-drop.service';
import { LmsTerminalBoundComponent } from '../lms-terminal-bound/lms-terminal-bound.component';
import { Tab } from './../../../core/model/tab.model';
import { TerminalStatus } from './../../../core/model/terminal-status.model';
import { TerminalSummary } from './../../../core/model/terminal-summary.model';
import { LmsModuleService } from './../../../core/services/lms-module.service';
import { StaticDataStoreService } from './../../../core/services/static-datastore.service';
import { AddToPendingList } from './../../shared/model/terminal-pending.model';
import { AddToPendingService } from './../../shared/services/add-to-pending.service';





/**
 * @export
 * @class LmsTerminalBoundListComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-terminal-bound-list',
  templateUrl: './lms-terminal-bound-list.component.html',
  styleUrls: ['./lms-terminal-bound-list.component.scss']
})

export class LmsTerminalBoundListComponent implements OnInit {
  statusHeaderActive: Boolean = false;
  // private terminalStateOpenList: Object;
  terminalStatusSubscription: any;
  addToPendingSubscribe: any;
  pendingActions: Array<AddToPendingList> = [];
  @Input() tab: Tab;
  @Input() allData: TerminalStatus;
  @Input() inOutBoundHeight: number;
  @Input() fullPageModeHeight: number;
  @Output() showLocoMenu: EventEmitter<Map<string, any>> = new EventEmitter<Map<string, any>>();
  @Output() showTrainMenu: EventEmitter<Map<string, any>> = new EventEmitter<Map<string, any>>();
  @Output() hideContextPanel: EventEmitter<true> = new EventEmitter<true>();
  @Output() heightCalculate: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild(LmsTerminalBoundComponent) lmsTerminalBoundComponent: LmsTerminalBoundComponent;
  terminalSummary: TerminalSummary;
  showHeader: Boolean;



  constructor(private lmsModuleService: LmsModuleService,
    private addToPendingService: AddToPendingService, private changeDetectorRef: ChangeDetectorRef,
    private appUtilityService: AppUtilityService, private lmsLoaderService: LmsLoaderService, private dataStoreService: DataStoreService,
    private lmsTabsDragDropService: LmsTabsDragDropService, private staticDataStoreService: StaticDataStoreService,) {
          if(staticDataStoreService.getValue('SHOW_HEADER') == false)
            this.showHeader = false;
          else
            this.showHeader = true;
  }

  ngOnInit() {
    if (this.allData && this.allData.terminalStatusLocos && this.allData.terminalStatusLocos.terminalSummary) {
      this.terminalSummary = this.allData.terminalStatusLocos.terminalSummary;
    }
  }

  /**
   * update screen size
   * @memberof LmsTerminalBoundListComponent
   */
  setScreenSize() {
    if (this.lmsTerminalBoundComponent) {
      this.lmsTerminalBoundComponent.updateScreenSize();
    }
  }

  /**
   * @memberOf LmsTerminalBoundListComponent
   */
  public hideLocoTrainContextPanel(event) {
    this.hideContextPanel.emit(event);
  }

  /**
   * emit this method  to calculate height of body
   * @param {any} event
   * @memberof LmsTerminalBoundListComponent
   */
  public heightCalculateEmit(event) {
    this.heightCalculate.emit(event);
  }

  /**
   * Shows Train Context Menu
   * @param {any} event
   * @memberOf LmsTerminalBoundListComponent
   */
  public showTrainContextMenu(event) {
    this.showTrainMenu.emit(event);
  }

  /**
   * Shows locoMotive Context MEnu
   * @param {any} event
   * @memberOf LmsTerminalBoundListComponent
   */
  public showLocomotiveContextMenu(event) {
    this.showLocoMenu.emit(event);
  }

  /**
   * @param {any} $event
   * @memberOf LmsTerminalBoundListComponent
   */
  toggleCollpase($event) {
    this.hideContextPanel.emit(true);
    if (!this.tab.openState) {
      this.tab.openState = { headerName: '', status: null, activeStatus: false, collpase: null };
    }
    this.tab.openState.collpase = $event.collpase;
    this.tab.openState.singleClick = $event.singleClick;
    this.tab.openState.headerName = $event.header;
    const tabData = {
      id: this.tab.id,
      subType: this.tab.subType,
      data: {}
    };
    tabData.data[this.tab.subType] = this.allData;
    this.dataStoreService.putValue(this.tab, tabData);
    //this.lmsModuleService.updateSelectedTab(this.tab);
    setTimeout(() => { this.lmsTabsDragDropService.updateInteractiveLocoTrains(); }, 100);

    this.heightCalculate.emit(true);
  }
}
